import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Footer from './Footer';

import style from '../style/landing_ui.module.css';
import logo from '../assets/LaunchScreen@2x.png';
import phone from '../assets/Phone@3xcopy.png';
import apple from '../assets/black.svg';
import google from '../assets/GetItOnGooglePlay_Badge_Web_color_English.png';
import gftlogo from '../assets/LOGO.png';
import header from '../assets/heading.png';

const LandingPage = () => {
return (
<div className={style.background}>
	<Container style={{ flex: 1 }}>
		<br />
		<Row className={style.pushFooter}>
			<Col idName={style.headerStyle}>
			<p className={style.body}>
				<img src={logo} alt="Grub Truck Logo" className={style.logo} />
				<br />
				<br />
				GrubTrucks is a free app that helps you find food trucks near you! Truck owners add their location in the app so you can use GPS to take you to their location!<br/><br/> If you are a food truck owner? Check out: <br/>
				<a href="https://grubtrucks.info/truckowners" className="btn">Grub Trucks for Food Truck Owners</a>
				<br />
				<br />
			<div className={style.appButtons}>
				<a href="https://apps.apple.com/us/app/grub-trucks/id1116325681?itsct=apps_box_badge&amp;itscg=30200" target="_blank" rel="noopener noreferrer">
					<img src={apple} className={style.appleButton} alt="Download on the App Store" />
				</a>
				<a href="https://play.google.com/store/apps/details?id=com.webdmg.grub.truck" target="_blank" rel="noopener noreferrer">
					<img src={google} className={style.googleButton} alt="Get it on Google Play" />
				</a>
			</div>
			</p>

			</Col>
			<Col className={style.hide}>
			<div className={style.phoneCenter}>
				<img src={phone} alt="Grub Truck Logo" className={style.phone} />
			</div>
			</Col>
		</Row>
	</Container>
	<Footer />
</div>
);
};

export default LandingPage;